
import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';


const JsonDictGrid = ({ headone, headtwo, data }) => {
  return (
    // <Box width={"30%"}>
      <TableContainer component={Paper}>
        <Table size="small" aria-label="DNA - Bot Folk Individual">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '1%', whiteSpace: 'nowrap', pl: '0.5rem', pr: '0.5rem' }}><strong>{headone}</strong></TableCell>
              <TableCell sx={{ width: '1%', whiteSpace: 'nowrap', pl: '0.7rem', pr: '0.5rem' }}><strong>{headtwo}</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(data).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell sx={{ width: '1%', whiteSpace: 'nowrap', pl: '0.5rem', pr: '0.5rem' }}>{key}</TableCell>
                <TableCell sx={{ width: '1%', whiteSpace: 'nowrap', pl: '0.5rem', pr: '0.5rem' }}>
                  {value === null ? 'null' : value.toString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    // </Box>
  );
};

export default JsonDictGrid;

